var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertPure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_23303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4895 15.9936L13.1562 6.66031C13.0399 6.45511 12.8713 6.28443 12.6675 6.16569C12.4637 6.04694 12.2321 5.98438 11.9962 5.98438C11.7604 5.98438 11.5287 6.04694 11.3249 6.16569C11.1211 6.28443 10.9525 6.45511 10.8362 6.66031L5.50288 15.9936C5.38534 16.1972 5.3237 16.4282 5.32422 16.6633C5.32474 16.8984 5.3874 17.1291 5.50585 17.3322C5.62429 17.5352 5.79431 17.7034 5.99868 17.8195C6.20304 17.9357 6.43449 17.9958 6.66955 17.9936H17.3362C17.5701 17.9934 17.7999 17.9316 18.0024 17.8145C18.2049 17.6974 18.373 17.529 18.4899 17.3264C18.6068 17.1237 18.6682 16.8939 18.6682 16.66C18.6681 16.426 18.6065 16.1962 18.4895 15.9936Z",
    stroke: "#3D0E6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10V12.6667V10Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10V12.6667",
    stroke: "#3D0E6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3438H12.0067H12Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3438H12.0067",
    stroke: "#3D0E6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_23303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPure);
export default __webpack_public_path__ + "static/media/alert-pure.7e392cee8163c172cf962d1c4b283ba7.svg";
export { ForwardRef as ReactComponent };